function initProducts() {
  const productsSliders = document.querySelectorAll('.products__slider');

  if (productsSliders.length) {
    productsSliders.forEach(slider => {
      const isMini = slider.classList.contains('products__slider--mini');
      const isBig = slider.classList.contains('products__slider--big');

      // Настройки по умолчанию
      let slidesPerView = 3;
      let grid = null;
      let breakpoints = null;

      if (isMini) {
        slidesPerView = 3;
        grid = {
          rows: 2,
          fill: 'row',
        };
        breakpoints = {
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 1.2,
          },
          1024: {
            slidesPerView: 2,
          },
          1280: {
            slidesPerView: 3,
          },
        };
      } else if (isBig) {
        slidesPerView = 4;

        breakpoints = {
          0: {
            slidesPerView: 2,
            spaceBetween: 5,
          },
          768: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 2.6,
            spaceBetween: 10,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 20,
          }
        };
      }

      const swiper = new Swiper(slider, {
        slidesPerView,
        spaceBetween: 20,
        ...(grid && { grid }),

        navigation: {
          nextEl: slider.querySelector('.swiper-navigation__btn--next'),
          prevEl: slider.querySelector('.swiper-navigation__btn--prev'),
        },

        breakpoints: {
          0: {
            slidesPerView: 1.2,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
        },

        ...(breakpoints && { breakpoints }),
      });
    });
  }
}

export { initProducts };
